module.exports = __webpack_public_path__ + "img/e4_img2.57125bd.jpg";